import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import * as localforage from 'localforage';
import { ApiBaseService } from '../services/api/api-base/api-base.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { ToasterService } from '../services/toaster/toaster.service';
// import { ToastrService } from 'ngx-toastr';
export interface IUser {
  _id: number;
  name: string;
  email: string;
  isDeleted: boolean;
  roles: string[];
  // eslint-disable-next-line @typescript-eslint/naming-convention
  access_token?: string;
}

@Injectable()
export class AuthService {
  private _currentUserSubject: BehaviorSubject<IUser>;
  token: string;
  public currentUser: Observable<IUser>;
  constructor(
    private _api: ApiBaseService,
    private _router: Router,
    private _toast: ToasterService,
  ) {
    this._currentUserSubject = new BehaviorSubject<IUser>(
      JSON.parse(localStorage.getItem('currentUser')),
    );
    this.currentUser = this._currentUserSubject.asObservable();
  }
  public get currentUserValue(): IUser {
    return this._currentUserSubject.value;
  }
  signupUser(): void {
    // your code for signing up the new user
  }

  signinUser(loginForm: any): void {
    // console.log('whatsap');
    this._api
      .post('users/login', {
        username: loginForm.email,
        password: loginForm.password,
      })
      .subscribe(
        (user) => {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem('currentUser', JSON.stringify(user));
          this._currentUserSubject = new BehaviorSubject<IUser>(
            JSON.parse(localStorage.getItem('currentUser')),
          );

          this._router.navigate(['']);
          this._toast.showSuccess('Login Successful');
          return user;
        },
        (err) => {
          console.log(err);
          this._toast.showError(err?.error?.message);
        },
      );

    // your code for checking credentials and getting tokens for for signing in user
  }

  logout(): void {
    localStorage.removeItem('currentUser');
    this._currentUserSubject.next(null);
    this.token = null;
    this.deleteAllData();
    this._router.navigate(['login']);
  }

  deleteAllData(): void {
    const dbName = 'talent-litmus-adminv2';
    localforage
      .dropInstance({ name: dbName })
      .then(() => {
        console.log(`Database ${dbName} deleted successfully!`);
      })
      .catch((err) => {
        console.log('Error in deleting Database: ', err);
      });
  }

  getToken(): string {
    return this.token;
  }

  isAuthenticated(): void {
    //   // console.log(this.currentUser)
    //   // here you can check if user is authenticated or not through his token
    //   if(this.currentUser.){
    //   return true;
    // }else{
    //   return false;
    // }
  }
}
